import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, CreditCard, ClipboardList, Shield, LogOut, MessageSquare } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_lyca-renewal-tracker/artifacts/wh5xa0xk_logo_new1.webp";

const navItems = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { to: "/customers", icon: Users, label: "Customers" },
  { to: "/plan-types", icon: CreditCard, label: "Plan Types" },
  { to: "/tasks", icon: ClipboardList, label: "Renewal Tasks" },
  { to: "/sms-settings", icon: MessageSquare, label: "SMS Settings" },
  { to: "/admin-users", icon: Shield, label: "Admin Users" },
];

const handleLogout = () => {
  sessionStorage.removeItem('lyca_auth');
  window.location.reload();
};

export default function Layout() {
  return (
    <div className="flex min-h-screen" data-testid="main-layout">
      {/* Sidebar */}
      <aside className="sidebar w-64 fixed h-screen" data-testid="sidebar">
        <div className="p-4 border-b border-slate-800">
          <img 
            src={LOGO_URL} 
            alt="Lyca Mobile" 
            className="h-10 w-auto"
            data-testid="logo"
          />
        </div>
        <nav className="py-4" data-testid="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? "active" : ""}`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-4 left-4 right-4 space-y-3">
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 text-slate-400 hover:text-white hover:bg-slate-800/50 transition-colors rounded-md text-sm"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
          <div className="text-xs text-slate-600 text-center">
            Lyca Mobile Ireland
            <br />
            Renewal Tracker v1.0
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-64 min-h-screen" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
}
